/**
 * Canicule : typewriter headline effect
 * - Desktop (>749px): character typewriter
 * - Mobile (≤749px): light full-phrase rotation (no char typing), pause 7–9s
 * - prefers-reduced-motion: static text (no animation)
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOBILE_MQ = '(max-width: 749px)';
  var MOBILE_DELAY_MIN = 7000;
  var MOBILE_DELAY_MAX = 9000;
  var MOBILE_DELAY_DEFAULT = 8000;
  var FADE_MS = 280;

  function shuffleArray(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = a[i];
      a[i] = a[j];
      a[j] = tmp;
    }
    return a;
  }

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function Typewriter(el) {
    this.el = el;
    this.textEl = el.querySelector('[data-typewriter-text]');
    this.cursorEl = el.querySelector('[data-typewriter-cursor]');
    this.speed = Number(el.getAttribute('data-typewriter-speed')) || 80;
    this.delay = Number(el.getAttribute('data-typewriter-delay')) || 3000;
    this.phrases = (el.getAttribute('data-typewriter-phrases') || '')
      .split('|||')
      .map(function (p) {
        return p.trim();
      })
      .filter(Boolean);

    if (!this.textEl || this.phrases.length === 0) return;

    if (prefersReducedMotion) {
      if (this.cursorEl) this.cursorEl.style.display = 'none';
      if (!this.textEl.textContent.trim()) {
        this.textEl.textContent = this.phrases[0];
      }
      return;
    }

    var isMobile = window.matchMedia(MOBILE_MQ).matches;

    if (isMobile) {
      if (this.cursorEl) this.cursorEl.style.display = 'none';
      var mobileDelay = Number(el.getAttribute('data-typewriter-mobile-delay')) || MOBILE_DELAY_DEFAULT;
      this.delay = clamp(mobileDelay, MOBILE_DELAY_MIN, MOBILE_DELAY_MAX);
      this.phrases = shuffleArray(this.phrases);
      this.index = 0;
      this.textEl.textContent = this.phrases[0];
      if (this.phrases.length > 1) {
        this.scheduleRotate();
      }
      return;
    }

    this.phrases = shuffleArray(this.phrases);
    this.index = 0;
    this.charIndex = 0;
    this.deleting = false;
    this.tick();
  }

  Typewriter.prototype.scheduleRotate = function () {
    var self = this;
    this._rotateTimer = setTimeout(function () {
      self.rotateNext();
    }, this.delay);
  };

  Typewriter.prototype.rotateNext = function () {
    var self = this;
    this.index = (this.index + 1) % this.phrases.length;
    this.textEl.classList.add('is-fading');
    setTimeout(function () {
      self.textEl.textContent = self.phrases[self.index];
      self.textEl.classList.remove('is-fading');
      self.scheduleRotate();
    }, FADE_MS);
  };

  Typewriter.prototype.tick = function () {
    var self = this;
    var phrase = this.phrases[this.index];

    if (!this.deleting) {
      this.textEl.textContent = phrase.substring(0, this.charIndex + 1);
      this.charIndex++;

      if (this.charIndex === phrase.length) {
        setTimeout(function () {
          self.deleting = true;
          self.tick();
        }, this.delay);
        return;
      }
      setTimeout(function () {
        self.tick();
      }, this.speed);
    } else {
      this.textEl.textContent = phrase.substring(0, this.charIndex - 1);
      this.charIndex--;

      if (this.charIndex === 0) {
        this.deleting = false;
        this.index = (this.index + 1) % this.phrases.length;
        setTimeout(function () {
          self.tick();
        }, 400);
        return;
      }
      setTimeout(function () {
        self.tick();
      }, this.speed * 0.6);
    }
  };

  function init() {
    document.querySelectorAll('[data-typewriter]').forEach(function (el) {
      if (el._caniculeTypewriterInit) return;
      el._caniculeTypewriterInit = true;
      new Typewriter(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
